const testimonials = [
  {
    name: "Ashley R.",
    location: "Grand Forks, ND",
    rating: 5,
    text: "As a UND grad student, I needed a passport for research travel to Europe. Fast Passport Center delivered in 7 days. Way better than trying to drive to Minneapolis on a grad student schedule. Super smooth process.",
    trip: "Research trip to the Netherlands",
  },
  {
    name: "Tom W.",
    location: "East Grand Forks, MN",
    rating: 5,
    text: "I'm on the Minnesota side of the border and Fast Passport Center still helped me without any issues. My renewal came back in 6 days. The agent was incredibly patient with my questions.",
    trip: "Family trip to Costa Rica",
  },
  {
    name: "Karen B.",
    location: "Grand Forks, ND",
    rating: 5,
    text: "My daughter needed her first passport for a school trip. Fast Passport Center walked us through the entire minor passport process — both parents consent, photos, everything. We had it in 8 days. Excellent for families.",
    trip: "Class trip to Canada",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Customer Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Grand Forks Travelers Say About Us
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real reviews from Grand Forks and northeastern North Dakota passport customers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-user-line text-[#1A365D]"></i>
                </div>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location} &middot; {t.trip}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}